// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   AI Assistant Panel — DataFlock design system
   ============================================================ */

:root {
  --ai-panel-width: 380px;
  --ai-panel-bg: rgba(8, 8, 8, 0.97);
  --ai-panel-blur: blur(20px);
  --ai-panel-border: rgba(116, 121, 255, 0.15);
  --ai-accent: #7479ff;
  --ai-accent-dim: rgba(116, 121, 255, 0.18);
  --ai-text-primary: #f2f2f2;
  --ai-text-secondary: #bdbdbd;
  --ai-tag-bg: rgba(53, 52, 59, 1);
  --ai-glass-bg: rgba(131, 131, 131, 0.12);
  --ai-separator: rgba(255, 255, 255, 0.08);
  --ai-bubble-user-bg: rgba(116, 121, 255, 0.22);
  --ai-bubble-ai-bg: rgba(131, 131, 131, 0.14);
  --ai-input-bg: rgba(255, 255, 255, 0.05);
  --ai-input-border: rgba(255, 255, 255, 0.1);
  --ai-radius-sm: 8px;
  --ai-radius-md: 12px;
  --ai-radius-lg: 16px;
  --ai-radius-pill: 100px;
  --ai-transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* ---------- Panel ---------- */
.ai-assistant-panel {
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: var(--ai-panel-width);
  max-width: 100vw;
  z-index: 1100;
  background: var(--ai-panel-bg);
  backdrop-filter: var(--ai-panel-blur);
  -webkit-backdrop-filter: var(--ai-panel-blur);
  border-left: 1px solid var(--ai-panel-border);
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform var(--ai-transition);
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, sans-serif;
  color: var(--ai-text-primary);
  overflow: hidden;
}

.ai-assistant-panel--open {
  transform: translateX(0);
}

/* ---------- Header ---------- */
.ai-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px;
  border-bottom: 1px solid var(--ai-separator);
  flex-shrink: 0;
}

.ai-panel-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ai-panel-header-icon {
  width: 22px;
  height: 22px;
  opacity: 0.9;
}

.ai-panel-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--ai-text-primary);
  letter-spacing: 0.01em;
}

.ai-panel-close-btn {
  background: none;
  border: none;
  color: var(--ai-text-secondary);
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--ai-radius-sm);
  transition: color 0.15s, background 0.15s;
}

.ai-panel-close-btn:hover {
  color: var(--ai-text-primary);
  background: rgba(255, 255, 255, 0.08);
}

/* ---------- Tabs ---------- */
.ai-panel-tabs {
  display: flex;
  gap: 4px;
  padding: 12px 20px 0;
  flex-shrink: 0;
}

.ai-tab {
  background: none;
  border: none;
  color: var(--ai-text-secondary);
  font-size: 13px;
  font-weight: 500;
  padding: 7px 16px;
  border-radius: var(--ai-radius-pill);
  cursor: pointer;
  transition: color 0.15s, background 0.15s;
}

.ai-tab:hover {
  color: var(--ai-text-primary);
  background: var(--ai-accent-dim);
}

.ai-tab--active {
  color: var(--ai-accent);
  background: var(--ai-accent-dim);
  font-weight: 600;
}

/* ---------- Panel Body ---------- */
.ai-panel-body {
  flex: 1 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 16px 0 0;
}

/* ---------- Chat Section ---------- */
.ai-chat-section {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  overflow: hidden;
  padding: 0 20px 16px;
  gap: 12px;
}

.ai-chat-messages {
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-right: 4px;
  scrollbar-width: thin;
  scrollbar-color: rgba(116, 121, 255, 0.3) transparent;
}

.ai-chat-messages::-webkit-scrollbar {
  width: 4px;
}

.ai-chat-messages::-webkit-scrollbar-thumb {
  background: rgba(116, 121, 255, 0.3);
  border-radius: 4px;
}

.ai-chat-empty {
  color: var(--ai-text-secondary);
  font-size: 14px;
  text-align: center;
  margin-top: 40px;
  line-height: 1.6;
}

.ai-chat-bubble {
  max-width: 85%;
  padding: 10px 14px;
  border-radius: var(--ai-radius-md);
  font-size: 14px;
  line-height: 1.55;
}

.ai-chat-bubble p {
  margin: 0;
}

.ai-chat-bubble--user {
  background: var(--ai-bubble-user-bg);
  color: var(--ai-text-primary);
  align-self: flex-end;
  border-bottom-right-radius: 4px;
}

.ai-chat-bubble--assistant {
  background: var(--ai-bubble-ai-bg);
  color: var(--ai-text-primary);
  align-self: flex-start;
  border-bottom-left-radius: 4px;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.ai-chat-bubble--loading {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--ai-text-secondary);
  font-size: 13px;
}

/* ---------- Chat Input ---------- */
.ai-chat-input-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  background: var(--ai-input-bg);
  border: 1px solid var(--ai-input-border);
  border-radius: var(--ai-radius-md);
  padding: 8px 8px 8px 12px;
  transition: border-color 0.15s;
}

.ai-chat-input-row:focus-within {
  border-color: var(--ai-accent);
}

.ai-chat-textarea {
  flex: 1 1;
  background: none;
  border: none;
  outline: none;
  color: var(--ai-text-primary);
  font-size: 14px;
  font-family: inherit;
  resize: none;
  line-height: 1.5;
  max-height: 120px;
  overflow-y: auto;
}

.ai-chat-textarea::placeholder {
  color: var(--ai-text-secondary);
}

.ai-chat-send-btn {
  flex-shrink: 0;
  background: var(--ai-accent);
  border: none;
  color: #fff;
  width: 34px;
  height: 34px;
  border-radius: var(--ai-radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.15s;
}

.ai-chat-send-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.ai-chat-send-btn:not(:disabled):hover {
  opacity: 0.85;
}

/* ---------- Spinner ---------- */
@keyframes ai-spin {
  to { transform: rotate(360deg); }
}

.ai-spinner {
  animation: ai-spin 0.9s linear infinite;
}

/* ---------- Summarize Section ---------- */
.ai-summarize-section {
  padding: 0 20px;
  overflow-y: auto;
  flex: 1 1;
  scrollbar-width: thin;
  scrollbar-color: rgba(116, 121, 255, 0.3) transparent;
}

.ai-summarize-section::-webkit-scrollbar {
  width: 4px;
}

.ai-summarize-section::-webkit-scrollbar-thumb {
  background: rgba(116, 121, 255, 0.3);
  border-radius: 4px;
}

.ai-section-separator {
  height: 1px;
  background: var(--ai-separator);
  margin: 8px 0 16px;
}

.ai-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.ai-section-tag {
  background: var(--ai-tag-bg);
  color: var(--ai-accent);
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: var(--ai-radius-pill);
  letter-spacing: 0.03em;
}

.ai-summarize-btn {
  background: var(--ai-accent-dim);
  border: 1px solid var(--ai-accent);
  color: var(--ai-accent);
  font-size: 13px;
  font-weight: 500;
  padding: 9px 20px;
  border-radius: var(--ai-radius-pill);
  cursor: pointer;
  transition: background 0.15s, opacity 0.15s;
  font-family: inherit;
}

.ai-summarize-btn:hover:not(:disabled) {
  background: rgba(116, 121, 255, 0.28);
}

.ai-summarize-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ai-summarize-btn--refresh {
  margin-top: 12px;
  font-size: 12px;
}

.ai-summarize-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--ai-text-secondary);
  font-size: 14px;
  margin: 8px 0;
}

.ai-summarize-error {
  color: #ff6b6b;
  font-size: 13px;
  margin-top: 8px;
}

/* ---------- Summary Block ---------- */
.ai-summary-block {
  background: var(--ai-glass-bg);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: var(--ai-radius-lg);
  padding: 18px;
  margin-top: 4px;
}

.ai-summary-title {
  font-size: 20px;
  font-weight: 500;
  color: var(--ai-text-primary);
  margin: 0 0 12px;
  font-family: Inter, ui-sans-serif, system-ui, sans-serif;
}

.ai-summary-body {
  font-size: 15px;
  font-weight: 400;
  color: var(--ai-text-primary);
  line-height: 1.65;
  margin: 0;
}

/* ---------- Customize Section ---------- */
.ai-customize-section {
  padding: 0 20px 20px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(116, 121, 255, 0.3) transparent;
}

.ai-customize-title {
  font-family: "NeoSans", sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: var(--ai-text-primary);
  margin: 0 0 16px;
  letter-spacing: 0.02em;
}

.ai-customize-group {
  margin-bottom: 16px;
}

.ai-customize-label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: var(--ai-text-secondary);
  margin-bottom: 8px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.ai-pill-group {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ai-pill {
  background: var(--ai-tag-bg);
  border: 1px solid transparent;
  color: var(--ai-text-secondary);
  font-size: 13px;
  font-weight: 400;
  padding: 6px 14px;
  border-radius: var(--ai-radius-pill);
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s, background 0.15s;
  font-family: inherit;
}

.ai-pill:hover {
  color: var(--ai-text-primary);
}

.ai-pill--active {
  color: var(--ai-accent);
  font-weight: 600;
  border-color: var(--ai-accent);
  background: var(--ai-accent-dim);
}

/* ---------- Responsive ---------- */
@media (max-width: 480px) {
  .ai-assistant-panel {
    width: 100vw;
  }
}

/* ---------- Active button state (when panel is open) ---------- */
.ai-assistant-btn--active {
  background: var(--ai-accent-dim) !important;
  color: var(--ai-accent) !important;
  border: 1px solid var(--ai-accent) !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/ai-assistant.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;EACE,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;EAC3B,4CAA4C;EAC5C,oBAAoB;EACpB,0CAA0C;EAC1C,0BAA0B;EAC1B,4BAA4B;EAC5B,gCAAgC;EAChC,wCAAwC;EACxC,yCAAyC;EACzC,8CAA8C;EAC9C,4CAA4C;EAC5C,wCAAwC;EACxC,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;EACrC,6CAA6C;EAC7C,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,0CAA0C;EAC1C,uEAAuE;EACvE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,8BAA8B;EAC9B,wCAAwC;EACxC,kCAAkC;EAClC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,eAAe;EACf,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,mCAAmC;EACnC,kCAAkC;EAClC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,SAAS;AACX;;AAEA,4CAA4C;AAC5C;EACE,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,eAAe;EACf,6DAA6D;EAC7D,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,qCAAqC;AACrC;EACE;IACE,YAAY;EACd;AACF;;AAEA,mEAAmE;AACnE;EACE,2CAA2C;EAC3C,kCAAkC;EAClC,6CAA6C;AAC/C","sourcesContent":["/* ============================================================\n   AI Assistant Panel — DataFlock design system\n   ============================================================ */\n\n:root {\n  --ai-panel-width: 380px;\n  --ai-panel-bg: rgba(8, 8, 8, 0.97);\n  --ai-panel-blur: blur(20px);\n  --ai-panel-border: rgba(116, 121, 255, 0.15);\n  --ai-accent: #7479ff;\n  --ai-accent-dim: rgba(116, 121, 255, 0.18);\n  --ai-text-primary: #f2f2f2;\n  --ai-text-secondary: #bdbdbd;\n  --ai-tag-bg: rgba(53, 52, 59, 1);\n  --ai-glass-bg: rgba(131, 131, 131, 0.12);\n  --ai-separator: rgba(255, 255, 255, 0.08);\n  --ai-bubble-user-bg: rgba(116, 121, 255, 0.22);\n  --ai-bubble-ai-bg: rgba(131, 131, 131, 0.14);\n  --ai-input-bg: rgba(255, 255, 255, 0.05);\n  --ai-input-border: rgba(255, 255, 255, 0.1);\n  --ai-radius-sm: 8px;\n  --ai-radius-md: 12px;\n  --ai-radius-lg: 16px;\n  --ai-radius-pill: 100px;\n  --ai-transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* ---------- Panel ---------- */\n.ai-assistant-panel {\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100vh;\n  width: var(--ai-panel-width);\n  max-width: 100vw;\n  z-index: 1100;\n  background: var(--ai-panel-bg);\n  backdrop-filter: var(--ai-panel-blur);\n  -webkit-backdrop-filter: var(--ai-panel-blur);\n  border-left: 1px solid var(--ai-panel-border);\n  display: flex;\n  flex-direction: column;\n  transform: translateX(100%);\n  transition: transform var(--ai-transition);\n  font-family: Inter, ui-sans-serif, system-ui, -apple-system, sans-serif;\n  color: var(--ai-text-primary);\n  overflow: hidden;\n}\n\n.ai-assistant-panel--open {\n  transform: translateX(0);\n}\n\n/* ---------- Header ---------- */\n.ai-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 20px 16px;\n  border-bottom: 1px solid var(--ai-separator);\n  flex-shrink: 0;\n}\n\n.ai-panel-header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.ai-panel-header-icon {\n  width: 22px;\n  height: 22px;\n  opacity: 0.9;\n}\n\n.ai-panel-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--ai-text-primary);\n  letter-spacing: 0.01em;\n}\n\n.ai-panel-close-btn {\n  background: none;\n  border: none;\n  color: var(--ai-text-secondary);\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--ai-radius-sm);\n  transition: color 0.15s, background 0.15s;\n}\n\n.ai-panel-close-btn:hover {\n  color: var(--ai-text-primary);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n/* ---------- Tabs ---------- */\n.ai-panel-tabs {\n  display: flex;\n  gap: 4px;\n  padding: 12px 20px 0;\n  flex-shrink: 0;\n}\n\n.ai-tab {\n  background: none;\n  border: none;\n  color: var(--ai-text-secondary);\n  font-size: 13px;\n  font-weight: 500;\n  padding: 7px 16px;\n  border-radius: var(--ai-radius-pill);\n  cursor: pointer;\n  transition: color 0.15s, background 0.15s;\n}\n\n.ai-tab:hover {\n  color: var(--ai-text-primary);\n  background: var(--ai-accent-dim);\n}\n\n.ai-tab--active {\n  color: var(--ai-accent);\n  background: var(--ai-accent-dim);\n  font-weight: 600;\n}\n\n/* ---------- Panel Body ---------- */\n.ai-panel-body {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  padding: 16px 0 0;\n}\n\n/* ---------- Chat Section ---------- */\n.ai-chat-section {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n  padding: 0 20px 16px;\n  gap: 12px;\n}\n\n.ai-chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-right: 4px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(116, 121, 255, 0.3) transparent;\n}\n\n.ai-chat-messages::-webkit-scrollbar {\n  width: 4px;\n}\n\n.ai-chat-messages::-webkit-scrollbar-thumb {\n  background: rgba(116, 121, 255, 0.3);\n  border-radius: 4px;\n}\n\n.ai-chat-empty {\n  color: var(--ai-text-secondary);\n  font-size: 14px;\n  text-align: center;\n  margin-top: 40px;\n  line-height: 1.6;\n}\n\n.ai-chat-bubble {\n  max-width: 85%;\n  padding: 10px 14px;\n  border-radius: var(--ai-radius-md);\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.ai-chat-bubble p {\n  margin: 0;\n}\n\n.ai-chat-bubble--user {\n  background: var(--ai-bubble-user-bg);\n  color: var(--ai-text-primary);\n  align-self: flex-end;\n  border-bottom-right-radius: 4px;\n}\n\n.ai-chat-bubble--assistant {\n  background: var(--ai-bubble-ai-bg);\n  color: var(--ai-text-primary);\n  align-self: flex-start;\n  border-bottom-left-radius: 4px;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n.ai-chat-bubble--loading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--ai-text-secondary);\n  font-size: 13px;\n}\n\n/* ---------- Chat Input ---------- */\n.ai-chat-input-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  background: var(--ai-input-bg);\n  border: 1px solid var(--ai-input-border);\n  border-radius: var(--ai-radius-md);\n  padding: 8px 8px 8px 12px;\n  transition: border-color 0.15s;\n}\n\n.ai-chat-input-row:focus-within {\n  border-color: var(--ai-accent);\n}\n\n.ai-chat-textarea {\n  flex: 1;\n  background: none;\n  border: none;\n  outline: none;\n  color: var(--ai-text-primary);\n  font-size: 14px;\n  font-family: inherit;\n  resize: none;\n  line-height: 1.5;\n  max-height: 120px;\n  overflow-y: auto;\n}\n\n.ai-chat-textarea::placeholder {\n  color: var(--ai-text-secondary);\n}\n\n.ai-chat-send-btn {\n  flex-shrink: 0;\n  background: var(--ai-accent);\n  border: none;\n  color: #fff;\n  width: 34px;\n  height: 34px;\n  border-radius: var(--ai-radius-sm);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: opacity 0.15s;\n}\n\n.ai-chat-send-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.ai-chat-send-btn:not(:disabled):hover {\n  opacity: 0.85;\n}\n\n/* ---------- Spinner ---------- */\n@keyframes ai-spin {\n  to { transform: rotate(360deg); }\n}\n\n.ai-spinner {\n  animation: ai-spin 0.9s linear infinite;\n}\n\n/* ---------- Summarize Section ---------- */\n.ai-summarize-section {\n  padding: 0 20px;\n  overflow-y: auto;\n  flex: 1;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(116, 121, 255, 0.3) transparent;\n}\n\n.ai-summarize-section::-webkit-scrollbar {\n  width: 4px;\n}\n\n.ai-summarize-section::-webkit-scrollbar-thumb {\n  background: rgba(116, 121, 255, 0.3);\n  border-radius: 4px;\n}\n\n.ai-section-separator {\n  height: 1px;\n  background: var(--ai-separator);\n  margin: 8px 0 16px;\n}\n\n.ai-section-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.ai-section-tag {\n  background: var(--ai-tag-bg);\n  color: var(--ai-accent);\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 12px;\n  border-radius: var(--ai-radius-pill);\n  letter-spacing: 0.03em;\n}\n\n.ai-summarize-btn {\n  background: var(--ai-accent-dim);\n  border: 1px solid var(--ai-accent);\n  color: var(--ai-accent);\n  font-size: 13px;\n  font-weight: 500;\n  padding: 9px 20px;\n  border-radius: var(--ai-radius-pill);\n  cursor: pointer;\n  transition: background 0.15s, opacity 0.15s;\n  font-family: inherit;\n}\n\n.ai-summarize-btn:hover:not(:disabled) {\n  background: rgba(116, 121, 255, 0.28);\n}\n\n.ai-summarize-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ai-summarize-btn--refresh {\n  margin-top: 12px;\n  font-size: 12px;\n}\n\n.ai-summarize-loading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--ai-text-secondary);\n  font-size: 14px;\n  margin: 8px 0;\n}\n\n.ai-summarize-error {\n  color: #ff6b6b;\n  font-size: 13px;\n  margin-top: 8px;\n}\n\n/* ---------- Summary Block ---------- */\n.ai-summary-block {\n  background: var(--ai-glass-bg);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: var(--ai-radius-lg);\n  padding: 18px;\n  margin-top: 4px;\n}\n\n.ai-summary-title {\n  font-size: 20px;\n  font-weight: 500;\n  color: var(--ai-text-primary);\n  margin: 0 0 12px;\n  font-family: Inter, ui-sans-serif, system-ui, sans-serif;\n}\n\n.ai-summary-body {\n  font-size: 15px;\n  font-weight: 400;\n  color: var(--ai-text-primary);\n  line-height: 1.65;\n  margin: 0;\n}\n\n/* ---------- Customize Section ---------- */\n.ai-customize-section {\n  padding: 0 20px 20px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(116, 121, 255, 0.3) transparent;\n}\n\n.ai-customize-title {\n  font-family: \"NeoSans\", sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--ai-text-primary);\n  margin: 0 0 16px;\n  letter-spacing: 0.02em;\n}\n\n.ai-customize-group {\n  margin-bottom: 16px;\n}\n\n.ai-customize-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--ai-text-secondary);\n  margin-bottom: 8px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.ai-pill-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.ai-pill {\n  background: var(--ai-tag-bg);\n  border: 1px solid transparent;\n  color: var(--ai-text-secondary);\n  font-size: 13px;\n  font-weight: 400;\n  padding: 6px 14px;\n  border-radius: var(--ai-radius-pill);\n  cursor: pointer;\n  transition: color 0.15s, border-color 0.15s, background 0.15s;\n  font-family: inherit;\n}\n\n.ai-pill:hover {\n  color: var(--ai-text-primary);\n}\n\n.ai-pill--active {\n  color: var(--ai-accent);\n  font-weight: 600;\n  border-color: var(--ai-accent);\n  background: var(--ai-accent-dim);\n}\n\n/* ---------- Responsive ---------- */\n@media (max-width: 480px) {\n  .ai-assistant-panel {\n    width: 100vw;\n  }\n}\n\n/* ---------- Active button state (when panel is open) ---------- */\n.ai-assistant-btn--active {\n  background: var(--ai-accent-dim) !important;\n  color: var(--ai-accent) !important;\n  border: 1px solid var(--ai-accent) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
